import { without } from 'lodash';
import { DirectSalesStatusOption } from 'components/common/types/DirectSalesCampaign.types';
import { POST_ALLOCATION_STATUSES, PRICED_STATUSES } from 'consts/directSalesPricedStates';

export const isDirectSalesLinePriced = (status: DirectSalesStatusOption): boolean => PRICED_STATUSES.includes(status);

export const isDirectSalesStatusPostAllocation = (status: DirectSalesStatusOption): boolean =>
  POST_ALLOCATION_STATUSES.includes(status);

export const isDirectSalesLinePricedWithoutCancelled = (status: DirectSalesStatusOption): boolean =>
  without(PRICED_STATUSES, DirectSalesStatusOption.CANCELLED).includes(status);
